import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	id: "flag-icons-in",
	viewBox: "0 0 640 480",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#f93",
			d: "M0 0h640v160H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 160h640v160H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#128807",
			d: "M0 320h640v160H0z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(3.2 0 0 3.2 320 240)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					r: 20,
					fill: "#008"
				}),
				/* @__PURE__ */ _jsx("circle", {
					r: 17.5,
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("circle", {
					r: 3.5,
					fill: "#008"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "d",
					children: [/* @__PURE__ */ _jsxs("g", {
						id: "c",
						children: [/* @__PURE__ */ _jsxs("g", {
							id: "b",
							children: [/* @__PURE__ */ _jsxs("g", {
								id: "a",
								fill: "#008",
								children: [/* @__PURE__ */ _jsx("circle", {
									r: .9,
									transform: "rotate(7.5 -8.8 133.5)"
								}), /* @__PURE__ */ _jsx("path", { d: "M0 17.5.6 7 0 2l-.6 5L0 17.5z" })]
							}), /* @__PURE__ */ _jsx("use", {
								xlinkHref: "#a",
								width: "100%",
								height: "100%",
								transform: "rotate(15)"
							})]
						}), /* @__PURE__ */ _jsx("use", {
							xlinkHref: "#b",
							width: "100%",
							height: "100%",
							transform: "rotate(30)"
						})]
					}), /* @__PURE__ */ _jsx("use", {
						xlinkHref: "#c",
						width: "100%",
						height: "100%",
						transform: "rotate(60)"
					})]
				}),
				/* @__PURE__ */ _jsx("use", {
					xlinkHref: "#d",
					width: "100%",
					height: "100%",
					transform: "rotate(120)"
				}),
				/* @__PURE__ */ _jsx("use", {
					xlinkHref: "#d",
					width: "100%",
					height: "100%",
					transform: "rotate(-120)"
				})
			]
		})
	]
});
export default SvgIn;
